module.exports = __webpack_public_path__ + "img/7fbd4c2.png";